import React from "react";
import styles from "../styles/styles";
import { getCategoryColor } from "../util/categoryColor";
export default function FireMatrix({
    cars = [],
    categoryLabel = "Incêndio",
    rows = [],
    matrixData = {}
}) {

    return (

        <div style={styles.fireWrapper}>

            <table style={styles.pantographTable}>

                <thead>
                    <tr>
                        <th style={{ width: "40px" }}></th>
                        <th style={{ width: "180px" }}></th>
                    </tr>
                </thead>

                <tbody>

                    {rows.map((row, rowIndex) => (

                        <tr key={rowIndex}>

                            {rowIndex === 0 && (
                                <td
                                    rowSpan={rows.length}
                                    style={styles.fireVertical}
                                >
                                    {categoryLabel}
                                </td>
                            )}

                            <td
                                style={{
                                    ...styles.fireLabel,

                                    borderTop:
                                        rowIndex === 0
                                            ? "1px solid #9ca3af"
                                            : "none",

                                    borderBottom:
                                        rowIndex === rows.length - 1
                                            ? "1px solid #9ca3af"
                                            : "none"
                                }}
                            >
                                {row.label}
                            </td>

                            {cars.map(car => {

                                const active =
                                    matrixData?.[car]?.[row.key];
                                const category =
                                    matrixData?.[car]?.[
                                    `${row.key}Category`
                                    ];

                                return (

                                    <td
                                        key={car}
                                        style={styles.fireCell}
                                    >

                                        <div
                                            style={{
                                                ...styles.fireBox,

                                                background:
                                                    active
                                                        ? (
                                                            getCategoryColor(
                                                                category
                                                            ) || "#ef4444"
                                                        )
                                                        : "#ffffff",

                                                color:
                                                    active
                                                        ? "#ffffff"
                                                        : "#111827"
                                            }}
                                        >
                                            {row.value}
                                        </div>

                                    </td>
                                );
                            })}

                        </tr>
                    ))}

                </tbody>

            </table>

        </div>
    );
}